import React from 'react';

import BCLLoading from '../../common/Loading/BCLLoading';
import './HomeAdvisor.scss';
class HomeAdvisor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
    let existingScript = document.getElementById('smEng-script');
    // Check if script has already been included or not (to avoid duplicate insertion)
    if (!existingScript) {
      let smEngEle = document.createElement('script');
      smEngEle.src = 'https://www.homeadvisor.com/js/smEngIframe.js';
      smEngEle.type = 'text/javascript';
      smEngEle.id = 'smEng-script';
      document.head.appendChild(smEngEle);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      window.smEng.iframeDefaults = {
        iframeUrl: this.props.configs['home_advisor_widget_url'],
        height: `${window.screen.height}px`,
        width: '100%'
      };
      this.setState({loading: false});
      window.smEng.setupIframe();
    }, 700);
  }

  render() {
    return(
      <div className="home-advisor">
        {!this.state.loading ? <div id="smEng"></div> : <BCLLoading />}
      </div>
    );
  }
}

export default HomeAdvisor;